import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../Button/Button';
import IconDropdown from '../Icon/IconDropdown';

import useOutsideClick from './useOutsideClick';

const HeaderNavDesktopItem = ({
  children,
  href,
  onClick,
  title,
  isDropdown,
  isActive,
  onBlur,
  target,
  addonClassname,
}) => {
  const className = cn(
    'c-header-main-nav__link',
    { 'c-header-main-nav__link--dropdown': isDropdown },
    { 'c-header-main-desktopNavItem': !isDropdown },
    { 'is-active': isActive },
    addonClassname
  );

  const ref = useRef();

  useOutsideClick(onBlur, { ref });

  return (
    <li ref={ref} className="c-header-main-nav__item">
      <Button
        className={className}
        color="none"
        href={href}
        onClick={onClick}
        target={target}
      >
        <span className="c-header-main-nav__text  u-truncate">{title}</span>
        {isDropdown && <IconDropdown className="c-header-main-nav__icon" />}
        <span className="c-header-main-nav__indicator" />
      </Button>
      {children}
    </li>
  );
};

export default HeaderNavDesktopItem;

HeaderNavDesktopItem.propTypes = {
  activates: PropTypes.string,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

HeaderNavDesktopItem.defaultProps = {
  activates: '',
  href: '',
  onClick: null,
};
